export const CLONE_ACTION = 'clone';
export const PUBLISH_ACTION = 'publish';
export const DRAFT_ACTION = 'draft';
export const LIVE_ACTION = 'live';

export const MULTI_LANG_CLONE_MESSAGE =
  'You\'re about to make a copy of the American English version of this page. Are you sure?';
export const MULTI_LANG_CLONE_BODY =
  'If you wish to enable other languages of this clone, you can do so from the American English clone.';
export const MULTI_LANG_PUBLISH_MESSAGE =
  `This action will publish only the American English version of this page.
   To publish another language version of this page, navigate to that page’s edit view.`;
export const MULTI_LANG_DRAFT_MESSAGE =
  `This action will make only the American English version of this page a draft.
   To make another language version of this page a draft as well, navigate to that page’s edit view.`;
export const DRAFT_BODY = 'Are you sure you want to make this page a draft?';
export const MULTI_LANG_LIVE_MESSAGE =
  `This will only make live and publish the American English version of this page.
   To make live and publish another language version of this page, navigate to that page’s edit view.`;
export const LIVE_MESSAGE = 'Making a page live will automatically publish the page.';
export const LIVE_BODY = 'Are you sure you want to make this page live?';
